import { __FLASH_VERSION__ } from '../constants';
import { flashVersion } from './flash-version';
import { isAndroid } from './is-android';
import { userAgentMatch } from './user-agent-match';

function lazyUserAgentMatch(regex): Function {
    return function () {
        return userAgentMatch(regex);
    };
}

export function isFlashSupported(): boolean {
    const version = flashVersion();
    return !!(version && version >= __FLASH_VERSION__);
}

export const isFF = lazyUserAgentMatch(/gecko\//i);
export const isIETrident = lazyUserAgentMatch(/trident\/.+rv:\s*11/i);
export const isIPod = lazyUserAgentMatch(/iP(hone|od)/i);
export const isIPad = lazyUserAgentMatch(/iPad/i);
export const isOSX = lazyUserAgentMatch(/Macintosh/i);
// Check for Facebook App Version to see if it's Facebook
export const isFacebook = lazyUserAgentMatch(/FBAV/i);

export function isEdge(): boolean {
    return userAgentMatch(/\sEdge\/\d+/i);
}

export function isMSIE(): boolean {
    return userAgentMatch(/msie/i);
}

export function isChrome(): boolean {
    return userAgentMatch(/\s(?:(?:Headless)?Chrome|CriOS)\//i) && !isEdge() && !userAgentMatch(/UCBrowser/i);
}

export function isIE(): boolean {
    return isEdge() || isIETrident() || isMSIE();
}

export function isSafari(): boolean {
    return userAgentMatch(/safari/i) && !userAgentMatch(/(?:Chrome|CriOS|chromium|android|phantom)/i);
}

export function isIOSWebView(): boolean {
    return isIOS() && !isSafari() && !isFF() && !isChrome();
}

export function isAndroidWebView(): boolean {
    return isAndroid() && !isSafari() && !isFF() && !isChrome();
}

export function isIOS(): boolean {
    return userAgentMatch(/iP(hone|ad|od)/i);
}

export function isAndroidNative(): boolean {
    // Android Browser appears to include a user-agent string for Chrome/18
    if (userAgentMatch(/chrome\/[123456789]/i) && !userAgentMatch(/chrome\/18/i) && !isFF()) {
        return false;
    }
    return isAndroid();
}

export function isMobile(): boolean {
    return isIOS() || isAndroid() || userAgentMatch(/Windows Phone/i);
}

export function isIframe(): boolean {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}
